'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/ArrowCircleUp.js";
var p = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var m = (e, r, o) => r in e ? p(e, r, { enumerable: true, configurable: true, writable: true, value: o }) : e[r] = o, a = (e, r) => {
  for (var o in r || (r = {}))
    s.call(r, o) && m(e, o, r[o]);
  if (t)
    for (var o of t(r))
      l.call(r, o) && m(e, o, r[o]);
  return e;
}, i = (e, r) => c(e, f(r));
const C = forwardRef((e, r) => /* @__PURE__ */ a__default.createElement(b, i(a({ ref: r }, e), { weights: t$1 })));
C.displayName = "ArrowCircleUp";
export {
  C as ArrowCircleUp
};
